import { Typography } from '@mui/material';
import React from 'react';

function Subheader({ text }) {
    return (
        <Typography
            variant='h6'
            component='div'
            style={{ fontWeight: 300, margin: '1rem 0', zIndex: 9 }}
        >
            {text}
        </Typography>
    );
}

export default Subheader;
